import * as Parse from 'parse';
import { StringModel } from '.';
import { ModelDecorator } from '../decorators';

interface IPrivacyPageModel {
    privacyText: StringModel
}

export default class Page extends Parse.Object {

    @ModelDecorator.Variable
    public name: string;

    @ModelDecorator.Variable
    public model: any;

    constructor() {
        super('Page')
        this.name = '';
        this.model = {};
    }

    // tslint:disable-next-line:member-ordering
    public static async getPrivacyPage(): Promise<Page> {
        const pages = await new Parse.Query(Page)
            .equalTo('name', 'privacy')
            .include('model.privacyText')
            .find()
        const privacyPage = pages[0] as Page;
        const privacyPageModel = privacyPage.model as IPrivacyPageModel;
        if (!privacyPageModel.privacyText) {
            privacyPageModel.privacyText = new StringModel();
        } else {
            const id = privacyPageModel.privacyText['objectId'] || privacyPageModel.privacyText.id
            privacyPageModel.privacyText = await StringModel.loadString(id);
        }
        return privacyPage;
    }

    public async savePrivacyPage() {
        const m = this.model as IPrivacyPageModel;
        await m.privacyText.save()
        await this.save()
    }
}

Parse.Object.registerSubclass('Page', Page);


// WEBPACK FOOTER //
// ./src/models/Page.ts